import { CategoryItem, RecommendedCategories } from '@kmx/recommended-categories';
import useAppState from '../../../common/state/appState';
import HomePageExperience from '../hero/store/HomePageExperience';
import { KmxContainer } from '../../../components/KmxContainer';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../../../utilities/analytics';

const getHostName = () => {
    if (typeof window !== 'undefined') {
        return window.location.hostname;
    }
    return '';
};

const onRecommendedCategoryClick = (_categoryData: unknown, selectedCategory: CategoryItem) => {
    trackEDDL({
        event: ANALYTICS_CONSTANTS.EVENTS.CLICK.SEARCH_INITIATED,
        linkDetails: {
            name: selectedCategory.categoryName,
            position: 'Try these next',
        },
        search: {
            initiationMethod: `Homepage|${selectedCategory.categoryName}|recommended categories`,
        },
    });
};

const RecommendedCategoriesWrapper = () => {
    const experience = useAppState((state) => state.experience);
    const pageType = 'Home';
    const viewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const stockNumber = viewedVehicles.length > 0 ? viewedVehicles[0].stockNumber.toString() : '';
    const heroThumbnailImageUrl = stockNumber.length
        ? `https://img2.carmax.com/assets/${stockNumber}/hero.jpg?width=200`
        : '';
    const isReturnVisit = experience == HomePageExperience.ReturnVisitor;

    return (
        <KmxContainer
            maxWidth="xl"
            sx={{
                mt: { xs: 5, sm: 6 },
            }}
        >
            <RecommendedCategories
                customBaseUrl={`https://${getHostName()}/home/api/recommended-categories`}
                heroThumbnailImageUrl={heroThumbnailImageUrl}
                pageType={pageType}
                stockNumber={stockNumber}
                isReturnVisit={isReturnVisit}
                onRecommendedCategoryClick={onRecommendedCategoryClick}
            />
        </KmxContainer>
    );
};

export default RecommendedCategoriesWrapper;
